export default async function scrollToTop() {
  await window.scrollTo(0, 0);
};
